import { rem } from 'polished';
import styled from 'styled-components';

import { breakpoints, misc } from 'helpers/styles/constants';

const OnboardingForm = styled.form<{ hasNoMaxWidth?: boolean }>`
  width: 100%;
  ${({ hasNoMaxWidth }) => !hasNoMaxWidth && `max-width: ${rem(misc.onboardingFormWidth)}`};

  @media ${breakpoints.xsUp} {
    width: auto;
  }
`;

export default OnboardingForm;
